/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Custom Boundary Icon component.
 */
export const SystemCustomBoundaryIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='20' y='20' width='16' height='16' transform='rotate(180 20 20)' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M19.5791 12.4209L4.42121 12.4209' stroke={iconColor} strokeWidth='1.5' />
      <path d='M10.1055 12.4209L10.1055 3.99984' stroke={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default SystemCustomBoundaryIcon;
